"use client";

import { ReactNode } from "react";

export type TravelFeatureCard = {
  key: string;
  title: string;
  description: string;
  bgColor: string;
  textColor: string;
  /** Tenant icon as a data URI or URL. Takes precedence over iconNode. */
  iconUrl?: string;
  /** Built-in icon, used when the tenant has not set one. */
  iconNode?: ReactNode;
};

type Props = {
  features: TravelFeatureCard[];
};

/**
 * Four cards fill the row on a wide screen and the row scrolls past that, so a
 * tenant can add cards without the layout deciding how many are allowed.
 */
export default function TravelFeatureCards({ features }: Props) {
  return (
    <div className="w-full flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2">
      {features.map((feature) => (
        <div
          key={feature.key}
          className="snap-start shrink-0 basis-[85%] sm:basis-[calc(50%-8px)] lg:basis-[calc(25%-12px)] flex flex-col gap-2 p-5 rounded-3xl"
          style={{
            backgroundColor: feature.bgColor,
            color: feature.textColor,
          }}
        >
          <span className="flex items-center justify-center bg-white p-2 rounded-full w-fit">
            {feature.iconUrl ? (
              // eslint-disable-next-line @next/next/no-img-element
              <img
                src={feature.iconUrl}
                alt=""
                className="w-6 h-6 object-contain"
              />
            ) : (
              feature.iconNode
            )}
          </span>
          <h2 className="font-bold font-switzer text-xl mb-0 md:mt-4">
            {feature.title}
          </h2>
          <p className="text-sm font-switzer mb-0 font-medium">
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  );
}
